// import { get, post } from '@/service/request';
import { get } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/transaction/record';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

/** 產生交易紀錄下載連結參數 */
export function getPdfRecordToken(regiNo) {
    return get(`${url}/getToken?regiNo=${regiNo}`, { ...options });
}
